import { render, staticRenderFns } from "./FlussiFatturaAnticipataModalEdit.vue?vue&type=template&id=2cf5301e"
import script from "./FlussiFatturaAnticipataModalEdit.vue?vue&type=script&lang=js"
export * from "./FlussiFatturaAnticipataModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports